$(document).foundation();
if (!window.matchMedia || !Modernizr.flexbox) {
    $('#' + $('html').attr('not-supported-modal')).foundation('open');
}